type Identifiable<T> = T & { id: number };

export const arrayToById = <T extends {}>(array: Identifiable<T>[]) =>
  array.reduce<{ [id: number]: T }>((obj, item) => {
    obj[item.id] = item;
    return obj;
  }, {});
